import { BaseResAPI } from "@/@core/entity/res-api.entity";
import api from "@/api/axios";

export interface UpdateLockStatusDTO {
  pathParams: {
    productNumber: number;
  };
  body: {
    is_lock: boolean;
  };
}

export type UpdateLockStatusResp = BaseResAPI<null>;

const updateLockStatusInteractor = async (
  params: UpdateLockStatusDTO
): Promise<UpdateLockStatusResp> => {
  const {
    pathParams: { productNumber },
    body,
  } = params;
  const path = `/admin/stock/${productNumber}`;
  return api.put(path, body);
};

export default updateLockStatusInteractor;
